import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const GoldDivider = ({ className = "" }) => (
  <div className={`gold-rule mx-auto w-40 ${className}`} aria-hidden="true" />
);

export const PageTitle = ({ children, testid, className = "" }) => (
  <h1 data-testid={testid} className={`mt-5 font-display text-5xl font-extrabold leading-[1.05] tracking-tight text-forest sm:text-6xl lg:text-7xl ${className}`}>
    {children}
  </h1>
);

export const SectionHeading = ({ eyebrow, title, sub, light = false, align = "center", big = false }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : "text-left"} max-w-3xl`}>
    {eyebrow && <p className={`eyebrow ${big ? "!text-sm" : ""}`} data-testid={`eyebrow-${eyebrow.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{eyebrow}</p>}
    <h2 className={`mt-4 font-display font-bold leading-[1.1] tracking-tight ${big ? "text-4xl sm:text-5xl lg:text-6xl" : "text-3xl sm:text-4xl lg:text-5xl"} ${light ? "text-cream" : "text-forest"}`}>
      {title}
    </h2>
    {sub && <p className={`mt-4 text-sm leading-relaxed sm:text-base ${light ? "text-cream/70" : "text-charcoal/70"}`}>{sub}</p>}
    {align === "center" && <GoldDivider className="mt-6" />}
  </div>
);
